/* eslint-disable no-case-declarations */
import moment from "moment-timezone";
import {
  BILLING_SEND_DOCUMENT_NUMBER_FAILURE,
  BILLING_GET_DOCUMENT_NUMBERS_REQUEST,
  BILLING_GET_DOCUMENT_NUMBERS_SUCCESS,
  BILLING_GET_DOCUMENT_NUMBERS_FAILURE,
  EVENT_BILLING_RESET_BILLERROR,
  EVENT_BILLING_FAILURE,
  EVENT_BILLING_REQUEST,
  EVENT_BILLING_SUCCESS,
  BILLING_SET_ERROR_MESSAGE,
  BILLING_GET_LEDGER_ENTRY_REQUEST,
  BILLING_GET_LEDGER_ENTRY_SUCCESS,
  BILLING_GET_LEDGER_ENTRIES_REQUEST,
  BILLING_GET_LEDGER_ENTRIES_SUCCESS,
  BILLING_PATCH_LEDGER_ENTRIES_SUCCESS,
  BILLING_DELETE_LEDGER_ENTRIES_REQUEST,
  BILLING_GET_LEDGER_ENTRIES_FAILURE,
  BILLING_DELETE_LEDGER_ENTRIES_SUCCESS,
  BILLING_CHECK_ERRORS_REQUEST,
  BILLING_CHECK_ERRORS_SUCCESS,
  BILLING_CHECK_ERRORS_FAILURE,
  BILLING_SET_FILTER,
  BILLING_CLEAR_FILTER,
  BILLING_DOCUMENT_SET_FILTER,
  BILLING_DOCUMENT_SET_NAV_COMPANY,
  BILLING_DOCUMENT_CLEAR_FILTER,
  BILLING_RESET_CONTRACT_REQUEST,
  BILLING_RESET_CONTRACT_SUCCESS,
  BILLING_RESET_CONTRACT_FAILURE,
  BILLING_SET_RESERVECONTRACTDATE,
  BILLING_SET_SETTLECONTRACTDATE,
  BILLING_MOVE_EVN_FAILURE,
  BILLING_MOVE_EVN_RESET_ERROR,
  BILLING_RESET_GETBILLERROR,
} from "../../actions/billing";
import { millisToFormatedDate } from "../../utils/dateTime";
import { NAV_COMPANYS } from "../../constants/constants";

export const ownMoment = moment();

ownMoment.tz("UTC");
const filterInit = {
  error: "",
  contract: "",
  productno: "",
  confId: "",
  status: "",
  orderBy: "",
  orderDirection: "",
  confStart: ownMoment.startOf("month").valueOf(),
  confEnd: ownMoment.endOf("month").valueOf(),
  name: "",
  requestFrom: "",
  participantName: "",
  bPhoneNumber: "",
  page: 0,
  amountOfLedgers: 10,
  billingPoint: "",
  billingTime: "",
};

const documentFilterInit = {
  paperOnly: false,
  fromEntryNo: "",
  toEntryNo: "",
  fromPostingDate: null,
  toPostingDate: null,
  dispatchComment: "",
  navCompany: NAV_COMPANYS[0],
};

export const initialState = {
  requestBillingInProgress: false, // TODO: rename
  ledgerEntries: [],
  currentLedgerEntry: null,
  filter: filterInit,
  navCompany: NAV_COMPANYS[0],
  errorMessage: "",
  billingEventContract: "",
  ledgerLength: 0,
  getBillErrorResponse: false,
  documentNumbers: [],
  documentErrorStatus: "",
  documentFilter: documentFilterInit,
  requestResetContract: false,
  reserveContractDate: undefined,
  settleContractDate: undefined,
  failureRequests: [],
  errorMessageEvn: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BILLING_RESET_GETBILLERROR:
      return {
        ...state,
        getBillErrorResponse: false,
      };
    case BILLING_CLEAR_FILTER:
      const newFilter = filterInit;
      return {
        ...state,
        filter: { ...newFilter, amountOfLedgers: state.filter.amountOfLedgers },
      };
    case BILLING_SET_FILTER:
      return {
        ...state,
        filter: { ...state.filter, ...action.filter },
      };
    case BILLING_DOCUMENT_SET_FILTER:
      return {
        ...state,
        documentFilter: action.filter,
      };
    case BILLING_DOCUMENT_SET_NAV_COMPANY:
      return {
        ...state,
        navCompany: action.company,
      };
    case BILLING_DOCUMENT_CLEAR_FILTER:
      return {
        ...state,
        documentFilter: documentFilterInit,
      };
    case BILLING_SET_ERROR_MESSAGE:
      return {
        ...state,
        requestBillingInProgress: false,
        errorMessage: action.errorMessage,
      };
    case BILLING_DELETE_LEDGER_ENTRIES_REQUEST:
      return {
        ...state,
        requestBillingInProgress: true,
        errorMessage: "",
      };
    case BILLING_GET_LEDGER_ENTRIES_REQUEST:
      return {
        ...state,
        requestBillingInProgress: true,
        errorMessage: "",
      };
    case BILLING_CHECK_ERRORS_REQUEST:
      return {
        ...state,
        requestBillingInProgress: true,
        errorMessage: "",
      };
    case BILLING_GET_LEDGER_ENTRY_REQUEST:
      return {
        ...state,
        requestBillingInProgress: true,
        errorMessage: "",
      };
    case EVENT_BILLING_RESET_BILLERROR:
      return {
        ...state,
        failureRequests: [],
      };
    case EVENT_BILLING_FAILURE:
      return {
        ...state,
        requestBillingInProgress: false,
        errorMessage: action.payload.message,
        getBillErrorResponse: true,
      };
    case EVENT_BILLING_REQUEST:
      return {
        ...state,
        requestBillingInProgress: true,
        billingEventContract: "",
        errorMessage: "",
        getBillErrorResponse: false,
      };
    case EVENT_BILLING_SUCCESS:
      return {
        ...state,
        billingEventContract: action.payload.successPayload,
        requestBillingInProgress: false,
        errorMessage: "",
      };
    case BILLING_GET_LEDGER_ENTRY_SUCCESS:
      const ledgerEntry = action.payload;
      const newEntry = {
        ...ledgerEntry,
        startTimeString: millisToFormatedDate(ledgerEntry.startTime),
        endTimeString: millisToFormatedDate(ledgerEntry.endTime),
      };
      return {
        ...state,
        requestBillingInProgress: false,
        currentLedgerEntry: newEntry,
        errorMessage: "",
      };
    case BILLING_GET_LEDGER_ENTRIES_SUCCESS:
      return {
        ...state,
        requestBillingInProgress: false,
        ledgerEntries: action.payload.ledgerEntry.map(it =>
          Object.keys(it).length === 0 && it.constructor === Object
            ? {}
            : {
                ...it,
                startTimeString: millisToFormatedDate(it.startTime),
                endTimeString: millisToFormatedDate(it.endTime),
              }
        ),
        ledgerLength: action.payload.size,
        errorMessage: "",
      };
    case BILLING_CHECK_ERRORS_FAILURE:
      return {
        ...state,
        ledgerEntries: [],
        ledgerLength: -1,
        requestBillingInProgress: false,
        currentLedgerEntry: null,
      };
    case BILLING_CHECK_ERRORS_SUCCESS:
      return {
        ...state,
        ledgerEntries: [],
        ledgerLength: -1,
        requestBillingInProgress: false,
        currentLedgerEntry: null,
      };
    case BILLING_DELETE_LEDGER_ENTRIES_SUCCESS:
      return {
        ...state,
        ledgerEntries: [],
        ledgerLength: -1,
        currentLedgerEntry: null,
      };
    case BILLING_PATCH_LEDGER_ENTRIES_SUCCESS:
      return {
        ...state,
        ledgerEntries: [],
        ledgerLength: -1,
        currentLedgerEntry: null,
      };
    case BILLING_GET_LEDGER_ENTRIES_FAILURE:
      return {
        ...state,
        requestBillingInProgress: false,
        errorMessage: action.payload.message,
        ledgerEntries: [],
      };
    case BILLING_GET_DOCUMENT_NUMBERS_REQUEST:
      return {
        ...state,
        requestBillingInProgress: true,
      };
    case BILLING_GET_DOCUMENT_NUMBERS_SUCCESS:
      return {
        ...state,
        documentNumbers: action.payload.successPayload,
        requestBillingInProgress: false,
      };
    case BILLING_GET_DOCUMENT_NUMBERS_FAILURE:
      return {
        ...state,
        requestBillingInProgress: false,
      };
    case BILLING_SEND_DOCUMENT_NUMBER_FAILURE: {
      const newArray = state.failureRequests;
      newArray.push(action.meta);
      return {
        ...state,
        failureRequests: newArray,
      };
    }
    case BILLING_RESET_CONTRACT_REQUEST:
      return {
        ...state,
        requestResetContract: true,
      };
    case BILLING_RESET_CONTRACT_SUCCESS:
      return {
        ...state,
        requestResetContract: false,
      };
    case BILLING_RESET_CONTRACT_FAILURE:
      return {
        ...state,
        requestResetContract: false,
        errorMessage: action.payload.message,
      };
    case BILLING_SET_RESERVECONTRACTDATE:
      return {
        ...state,
        reserveContractDate: action.date,
      };
    case BILLING_SET_SETTLECONTRACTDATE:
      return {
        ...state,
        settleContractDate: action.date,
      };
    case BILLING_MOVE_EVN_FAILURE:
      return {
        ...state,
        errorMessageEvn: action.payload.message,
      };
    case BILLING_MOVE_EVN_RESET_ERROR:
      return {
        ...state,
        errorMessageEvn: "",
      };
    default:
      return state;
  }
};
